import i18n from 'modules/core/lib/i18n'

import { TrainingMembershipStatusTag } from 'modules/trainings/components/Shared/TrainingMembershipStatusTag'

export const statusFilterOptions = () => {
  return [
    {
      label: i18n.t('trainings.my_training.all_courses_table.completed'),
      value: 'completed',
      component: <TrainingMembershipStatusTag status="completed" />,
    },
    {
      label: i18n.t('trainings.my_training.all_courses_table.absent'),
      value: 'missing',
      component: <TrainingMembershipStatusTag status="missing" />,
    },
    {
      label: i18n.t('trainings.my_training.all_courses_table.not_started'),
      value: 'notstarted',
      component: <TrainingMembershipStatusTag status="notstarted" />,
    },
    {
      label: i18n.t('trainings.my_training.all_courses_table.partially_completed'),
      value: 'partiallycompleted',
      component: <TrainingMembershipStatusTag status="partiallycompleted" />,
    },
    {
      label: i18n.t('trainings.my_training.all_courses_table.started'),
      value: 'started',
      component: <TrainingMembershipStatusTag status="started" />,
    },
  ]
}
